import React from "react";
import { IoClose } from "react-icons/io5";
import UpgradePlanIcon from "../../../assets/UpgradePlanIcon.svg";
import { activePlansUpdated, handleCheckoutHybrid } from "../../../store/actions";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-hot-toast";
import { authService } from "../../../services/authService";
import { useNavigate } from "react-router-dom";
import moment from "moment";

function UpgradePlanPopover({ data, handleClose }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const customerId = authService.getCurrentUserCustomerId();
  const userId = authService.getCurrentUserID();
  const token = authService.getCurrentUserVerificationCode();
  const { selectedProductId } = useSelector((state) => state.modal);

  const buildPlanItemsXML = (cartItems) => {
    return cartItems.map((item) => `
    <a>
      <sku>${item?.plan_code}</sku>
      <price>${item?.price}</price>
      <quantity>${+item?.quantity}</quantity>
      <billing_cycles>0</billing_cycles>
      <recuring_infinity>0</recuring_infinity>
      <recipient_refno>0</recipient_refno>
    </a>
  `);
  };

  function removeSpacesAndNewlines(xml) {
    return xml
      .replace(/\s{2,}/g, '')     // collapse multiple spaces
      .replace(/>\s+</g, '><')    // remove newlines and spaces between tags
      .trim();
  }

  const handlePlanUpgrade = async () => {
    try {
      const toastId = toast.loading("Upgrading Plan... please wait...");

      const payload = {
        customer_id: customerId,
        customer_pin: "",
        discount_amount: 0,
        coupon_code: "",
        item_info: "",
        c_code: 1001,
        user_id: userId,
        user_token: token,
        applicaton_id: 2,
        subscription_ref_no: selectedProductId?.id.toString(),
        option: 5,
      };

      let cartItemsXML = [];

      cartItemsXML = buildPlanItemsXML([data]);

      const allItems = [...cartItemsXML].filter(Boolean);
      const xmlStructure = `<root>${allItems.join('')}</root>`;
      const formattedItems = removeSpacesAndNewlines(xmlStructure);

      const finalPayload = {
        ...payload,
        item_info: formattedItems,
      };

      const res = await dispatch(handleCheckoutHybrid(finalPayload)).unwrap();

      if (res?.status === 403) {
        handleClose();
        return toast.error("Subscriptions could not be created...", { id: toastId });
      }

      if (!res?.Result) {
        handleClose();
        return toast.error("Subscriptions could not be created...", { id: toastId });
      }

      handleClose();
      dispatch(activePlansUpdated(customerId)).unwrap().then(() => navigate("/home"));
      return toast.success(res.Message_Text, {
        id: toastId,
      });
    } catch (err) {
      return err;
    }
  };

  return (
    <div className="rounded-2xl bg-white">
      <div className="flex justify-end px-4 py-4 xsm:px-6">
        <button
          onClick={handleClose}
          className="rounded-full p-2 hover:bg-gray-200 active:bg-gray-300"
        >
          <IoClose className="h-5 w-5 text-gravel-500" />
        </button>
      </div>
      <div className="px-4">
        <div className="flex items-center justify-center space-x-2 pt-3">
          <img src={UpgradePlanIcon} alt="icon" className="h-4 w-4" />
          <h3 className="font-semibold text-gray-700">Upgrade Plan</h3>
        </div>
        <p className="mt-1 pb-4 text-center text-sm text-gray-500">
          Are you sure you want to upgrade from your current plan to this plan?
          <br />
          {`The upgraded plan will start on the ${moment(
            selectedProductId?.nextBilling
          ).format("DD MMMM YYYY")}}. (Anniversary
          of your subscription).`}
        </p>
      </div>
      <div className="flex flex-col space-y-4 px-4 pb-6">
        <button
          onClick={() => handlePlanUpgrade()}
          className="w-full rounded-md bg-olivine-500 py-3 font-semibold text-white transition-all duration-200 hover:bg-olivine-400 focus:outline-none focus:ring-[2px] focus:ring-olivine-500 focus:ring-opacity-60 focus:ring-offset-1 active:bg-olivine-600"
        >
          Upgrade plan
        </button>
        <button
          onClick={handleClose}
          className="w-full rounded-md border-[1px] border-olivine-500 bg-white py-3 font-semibold capitalize text-olivine-500 transition-all duration-200 first:uppercase hover:bg-olivine-50 focus:outline-none focus:ring-[2px] focus:ring-olivine-500 focus:ring-opacity-60 focus:ring-offset-1 active:bg-olivine-100"
        >
          Back
        </button>
      </div>
    </div>
  );
}

export default UpgradePlanPopover;
